import { Card, Flex } from 'antd'
import { useParams } from 'react-router-dom'

import { GetSimeTbTreatmentPlanResponse } from 'src/api/requests'
import { Text } from 'src/components'
import { usePersonBreadcrumb } from 'src/features/persons/hooks'
import { useLocales } from 'src/locales'

import { useStyles } from '../PersonTreatmentsSection/components/styles'

import { SimeTBTreatment } from './SimeTBTreatment'

type Props = {
  data?: GetSimeTbTreatmentPlanResponse
}

export const SimeTBTreatmentBody = ({ data }: Props) => {
  const { t } = useLocales()

  const { styles } = useStyles()
  const { personId } = useParams()

  const { person } = usePersonBreadcrumb(personId)

  return (
    <Flex gap={16} vertical>
      <Card className={styles.treatmentCard}>
        <Flex key={1} vertical gap={24} className={styles.treatmentContent}>
          <Text size="xl">{t('persons.treatment.treatment_prescribed')}</Text>
          <SimeTBTreatment person={person} data={data} />
        </Flex>
      </Card>
    </Flex>
  )
}
